/**
 * src/data.js
 * Centralized data for services and region links
 */

export const servicesData = [
  {
    icon: '🌐',
    title: 'Web Development',
    description: 'Custom websites and web applications built with cutting-edge technologies for businesses of all sizes.'
  },
  {
    icon: '📱',
    title: 'Mobile Solutions',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences.'
  },
  {
    icon: '🛒',
    title: 'E-Commerce',
    description: 'Powerful online stores with secure payment integration and inventory management systems.'
  },
  {
    icon: '☁️',
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure and deployment services for modern businesses.'
  },
  {
    icon: '🎨',
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces that engage users and drive conversions.'
  },
  {
    icon: '🔧',
    title: 'Maintenance & Support',
    description: 'Ongoing technical support and maintenance to keep your digital assets running smoothly.'
  }
];

export const regionLinksData = [
  {
    href: 'https://sa.flycodeinv.com',
    target: '_blank',
    className: 'btn-sa',
    flag: '🇿🇦',
    text: 'South Africa'
  },
  {
    href: 'https://nga.flycodeinv.com',
    target: '_blank',
    className: 'btn-nigeria',
    flag: '🇳🇬',
    text: 'Nigeria'
  },
  {
    href: 'hhttps://sa.flycodeinv.com/echorift',
    target: '_blank',
    className: 'btn-nigeria',
    flag: null,
    text: 'Echo Rift'
  },
  {
    href: 'https://forlet.com.ng',
    target: '_blank',
    className: 'btn-sa',
    flag: null,
    text: 'ForLet'
  },
  {
    href: 'https://master-uwa.free.nf',
    target: '_blank',
    className: 'btn-sa',
    flag: null,
    text: 'MasterUwa'
  },
  {
    href: 'https://mariellashop.free.nf/?i=1',
    target: '_blank',
    className: 'btn-nigeria',
    flag: null,
    text: 'eCommerce Demo'
  }
];